<template>
  <v-dialog v-model="viewPromoOutletDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Promo Card Outlet') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="grey lighten-3">
        <v-layout row wrap>
          <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
            <v-layout row wrap>
              <v-flex xs12 class="pb-3">
                <div class="caption no-select">
                  {{ $t('Promo Card Outlet') }}
                </div>
                <strong v-for="(outlet, index) in promoOutlets" :key="index">
                  <v-chip>{{ outlet }}</v-chip>
                </strong>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider light />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'view-promo-outlet-component',

  props: {
    viewPromoOutletDialog: { type: Boolean, required: true },
    promoOutlets: { type: Array, required: true },
    promoCardId: { type: String, required: true }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewPromoOutletDialog) {
        this.$emit('hidemodal')
      }
    })
  }
}
</script>

<style scoped></style>
